module.exports = __webpack_public_path__ + "img/single-info.9e2428d9.svg";